import dayjs from "dayjs";
import { useForecastContext } from "../../../../../../context/forecastContext";
import SkeletonLoader from "../../../../../SkeletonLoader";
import ErrorMessage from "../../../../../errorMessage/errorMessage";
import { findForecastForDay } from "../../../../../../utilities/forecastHelpers";
import "./weekDayForecastMetrics.css";
import { useForecastQuery } from "../../../../../../services/forecastService";

type WeekDayForecastMetricsProps = {
  day: dayjs.Dayjs;
};

const WeekDayForecastMetrics: React.FC<WeekDayForecastMetricsProps> = ({
  day,
}) => {
  const { forecastState } = useForecastContext();
  const {
    data: forecasts,
    isLoading,
    isError,
  } = useForecastQuery({
    mdrSiteId: forecastState.selectedSite?.mdrSiteId!,
    siteId: forecastState.selectedSite?.siteId!,
    orgId: forecastState.selectedSite?.organisationId!,
    searchPeriod: forecastState.searchPeriod,
  });

  if (isLoading) {
    return <SkeletonLoader />;
  }
  if (isError) {
    return <ErrorMessage dataType="Forecast" fontSize="11px" />;
  }

  const forecast = findForecastForDay(
    day.format("YYYY-MM-DD"),
    forecasts ?? []
  );

  // if (!forecast) {
  //   return <SkeletonLoader />;
  // }

  if (!forecast) {
    return <>No Data</>;
  }

  return (
    <div className="week-day-forecast-metrics-container">
      {forecast ? "Data" : "No Data"}
    </div>
  );
};

export default WeekDayForecastMetrics;
